import { ActionTypes } from './constants'

const initialState = {
    data: [],
    filterData: '',
    
    data2: [],
    filterData2: '',
};

const tableReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SET_DATA:
            return {...state, data: payload }
        case ActionTypes.SET_FILTER_DATA:
            return {...state, filterData: payload}
        case ActionTypes.EDIT_DATA_BY_ID:
            return {...state, data: state.data.map(item=>{
                if(item.rowNo == payload.rowNo) item = payload;
                return item;
            })}

        case ActionTypes.SET_DATA2:
            return {...state, data2: payload }
        case ActionTypes.SET_FILTER_DATA2:
            return {...state, filterData2: payload}
        default:
            return state;
    }
};

export default tableReducer;